import storeHooks from '../common/globalHooks';

function splitClassName(constructor: any) {
    const value = /function (.*?)\(/.exec(constructor);
    return value ? (value[1] ? value[1] : null) : null;
}

export function Action(target: any, name: string, descriptor: any) {
    let method = descriptor.value;
    const className = splitClassName(target.constructor);
    descriptor.value = async function(arg: any = null) {
        const state = await method.call(this, arg);
        if (storeHooks) {
            storeHooks.emit('vue-store:mutation', {
                type: className,
                payload: arg,
                state
            });
        }
    };
}
